import React, { useState } from "react";
import { format } from "date-fns";
import { VacationRequest } from "../types";

interface RejectReasonModalProps {
  request: VacationRequest;
  saving: boolean;
  onSubmit: (reason: string) => void;
  onCancel: () => void;
}

/**
 * Modal that collects the mandatory rejection reason when an admin rejects a vacation request.
 */
const RejectReasonModal: React.FC<RejectReasonModalProps> = ({
  request,
  saving,
  onSubmit,
  onCancel,
}) => {
  const [reason, setReason] = useState("");
  const trimmed = reason.trim();

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "8px",
        maxWidth: "500px",
        width: "90%",
      }}>
        <h3>Urlaubsantrag ablehnen</h3>
        <p>
          Antrag für {request.employeeName || request.employeeUserId}{" "}
          vom {format(new Date(request.startDate), "d. MMM")} bis{" "}
          {format(new Date(request.endDate), "d. MMM yyyy")} ablehnen
        </p>

        <div style={{ marginTop: "15px" }}>
          <label htmlFor="rejectionReason" style={{
            display: "block",
            marginBottom: "5px",
            fontWeight: "bold"
          }}>
            Ablehnungsgrund (erforderlich):
          </label>
          <textarea
            id="rejectionReason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Bitte gib einen Grund für die Ablehnung an..."
            rows={4}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              resize: "vertical"
            }}
            autoFocus
          />
        </div>

        <div style={{
          marginTop: "20px",
          display: "flex",
          gap: "10px",
          justifyContent: "flex-end"
        }}>
          <button
            onClick={onCancel}
            className="view-button"
            style={{ backgroundColor: "#6c757d" }}
          >
            Abbrechen
          </button>
          <button
            onClick={() => onSubmit(trimmed)}
            disabled={!trimmed || saving}
            className="view-button"
            style={{
              backgroundColor: "#dc3545",
              cursor: !trimmed || saving ? "not-allowed" : "pointer",
              opacity: !trimmed || saving ? 0.6 : 1,
            }}
          >
            {saving ? "Wird abgelehnt..." : "Ablehnung bestätigen"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectReasonModal;
